module.exports = __webpack_public_path__ + "img/icon_info.16ce9fc2.svg";